import { Button, Divider, Select, Input, Tabs, notification, } from "antd";
import { CustomModal } from "../common/CustomModal";
import * as React from "react";
import { Layout, DatePicker, Upload } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";
import * as la from "lodash";
import { addUser } from "../../Graphs/User/addUser";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { checkPermission } from "../AdminUser/CheckAdminPermission";
import { UploadOutlined } from "@ant-design/icons";
import { addBulkUser } from "../../Graphs/User/bulkUser";
import { uploadGroupCsv } from "../../Graphs/User/fileUpload";
import { message } from "antd";
import { getDepartments } from "../../Graphs/Department/GetDepartment";
import { AssignCourse } from "../../Graphs/User/AssignCourse";
// import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { FetchCourse } from "../../Graphs/User/FetchCourse";
import { getAllUser } from "../../Graphs/User/listUser";
import { exportUsers } from "../../Graphs/User/exportUser";
import { getCorporateGroups } from "../../Graphs/CorporateGroups/lsitCorporateGroups";

const { Content } = Layout;
const Option = Select.Option;

const Dragger = Upload.Dragger;

const StyledDragger = styled(Dragger)`
  & .ant-upload {
    margin-bottom: 15px;
  }

  & .ant-upload-drag {
    margin-bottom: 15px;
  }
  & .ant-upload-list-item-actions {
    display: none;
  }
`;


export class AddUser extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      bulkUploadVisible: false,
      selectedType: "",
      isVerified: false,
      selectedDob: "",
      file: null,
      userList: [],
      image: null,
      departments: [],
      corporateGroups: [],
      //   selectedDepartment: this.props.data.department_id
      // ? Array.isArray(this.props.data.department_id)
      //     ? this.props.data.department_id.map(item => item.name) // If array, map through it
      //     : [this.props.data.department_id.name] // If single object, wrap it in an array
      // : [],

      selectedCourses: [{ courses: null, maxUsers: "" }],
      courses: [],
      assignCourseVisible: false,

      errors: {
        email: "",
      },
    };
  }

  input;
  allDepartments = [];

  fetchUserList = async () => {
    const { Token } = this.props;
    let userData = await getAllUser(Token, 0, 100);
    console.log(userData);
  };

  validateForm = (values) => {
    // const { selectedDob } = this.state;

    const { LoginData } = this.props;
    const errors = {};
    console.log("Validating form -- ", values);

    if (!values.email) {
      errors.email = "Email is required";
    } else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        String(values.email).toLowerCase()
      )
    ) {
      errors.email = "Please enter a valid email";
    }

    if (!values.first_name) {
      errors.first_name = "First name is required";
    }

    if (!values.last_name) {
      errors.last_name = "Last name is required";
    }

    if (LoginData.role === "corporate") {
      if (values.selectedDepartment.length === 0) {
        errors.selectedDepartment = "Department Name is required";
      }
    }

    console.log("Validating errors -- ", errors);

    return errors;
  };

  handleSubmit = async (values, action) => {
    values.department_id = values.selectedDepartment;
    delete values.selectedDepartment;
    if (!values.group_id) {
      delete values.group_id;
    }
    console.log("Final Payload:", values);

    await this.props.onSubmit(values);
    this.setState({
      visible: false,
    });
  };

  async fetchCourses() {
    try {
      const { Token } = this.props;
      const response = await FetchCourse(Token);

      if (
        response &&
        response.data &&
        response.data.length > 0 &&
        response.data[0].courses &&
        response.data[0].courses.courseDetails
      ) {
        this.setState({
          courses: response.data,
        });

        this.allCourses = response.data.map((item) => (
          <Option
            key={item.courses.courseDetails._id}
            value={item.courses.courseDetails._id}
          >
            {item.courses.courseDetails.name}
          </Option>
        ));

        this.setState({
          selectedCourses: response.data[0].courses.courseDetails._id,
        });
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  }

  // handleAssignSubmit = async () => {
  //   const { selectedCourses } = this.state;
  //   const { authToken, groupId } = this.props;

  //   if (selectedCourses.every((item) => item.course && item.maxUsers)) {
  //     try {
  //       const payload = {
  //         group_id: groupId,
  //         courses: selectedCourses.map((item) => ({
  //           course_id: item.course,
  //           max_user_count: item.maxUsers,
  //         })),
  //       };

  //       console.log("Submitting:", payload);

  //       const response = await AssignGroupCourse(authToken, payload);
  //       // console.log("Response:", response);

  //       if (response && response.status === 200) {
  //         notification.success({
  //           message: "Success",
  //           description: "Courses assigned successfully!",
  //         });
  //         this.setState({ visible: false });
  //       } else if (response) {
  //         notification.error({
  //           message: "Error",
  //           description: response.message || "Failed to assign courses.",
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error submitting courses:", error);
  //       notification.error({
  //         message: "Error",
  //         description: "Failed to assign courses. Please try again.",
  //       });
  //     }
  //   } else {
  //     alert("Please fill all fields.");
  //   }
  // };

  changeType = (value) => {
    this.setState({
      selectedType: value,
    });
  };

  // changeDob = (date, dateString) => {
  //   this.setState({
  //     selectedDob: dateString,
  //   });
  // };

  // handleDepartmentChange = async (value) => {
  //   this.setState({ selectedDepartment: value });

  //   const { authToken } = this.props;

  //   try {
  //     const departmentData = {
  //       name: value, // Assuming department data includes 'name'
  //     };

  //     const response = await updateDepartment(authToken, departmentData);
  //     if (response && response.status === 200) {
  //       message.success("Department updated successfully!");
  //     } else {
  //       message.error("Failed to update department");
  //     }
  //   } catch (error) {
  //     console.error("Update Department Error:", error);
  //     message.error("Failed to update department");
  //   }
  // };

  async componentDidMount() {
    const { Token, LoginData } = this.props;

    this.fetchCourses();

    let DepartmentData = await getDepartments(Token);

    if (DepartmentData.data && DepartmentData.data.length >= 1) {
      this.setState({ departments: DepartmentData.data });
      DepartmentData.data.map((data, index) => {
        this.allDepartments.push(
          <Option value={data._id} key={data._id}>
            {data.name}
          </Option>
        );
      });
    }

    if (LoginData && (LoginData.role === "SUPERADMIN" || LoginData.role === "SUBADMIN" || LoginData.role === "admin")) {
      try {
        const response = await getCorporateGroups(Token, 0, 1000);
        if (response && response.status === 200) {
          this.setState({ corporateGroups: response.data || [] });
        }
      } catch (err) {
        console.error("Failed to fetch corporate groups:", err);
      }
    }
  }

  handleAssignChange = (index, field, value) => {
    this.setState((prevState) => {
      const updatedCourses = [...prevState.selectedCourses];
      updatedCourses[index][field] = value;
      return { selectedCourses: updatedCourses };
    });
  };

  handleBulkUpload = async () => {
    const { file } = this.state;

    const { Token } = this.props;
    console.log("++++", Token);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const csvResponse = await uploadGroupCsv(Token, formData);
      console.log("CSV Upload Response:", csvResponse.file);

      const fileName = csvResponse.file;
      console.log("File Name:", fileName);

      if (fileName) {
        console.log("Adding Bulk Users...");

        try {
          const userResponse = await addBulkUser(Token, file, fileName);
          console.log("User Response: ", userResponse);

          if (userResponse && userResponse.status === 200) {
            message.success("Bulk users added successfully!");
            this.setState({ bulkUploadVisible: false, file: null });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            message.error(
              userResponse && userResponse.message
                ? userResponse.message
                : (userResponse && userResponse.data && userResponse.data.message)
                  ? userResponse.data.message
                  : "Failed to add bulk users."
            );
          }
        } catch (error) {
          console.error("Add Bulk Users Error:", error);
          message.error("Failed to add bulk users.");
        }
      } else {
        message.error("Failed to get file name from CSV response.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Failed to upload files.");
    }
  };

  handleAssignCourse = async () => {
    const { selectedCourses, selectedDepartment } = this.state;
    const { Token } = this.props;

    if (selectedCourses.length && selectedDepartment.length) {
      try {
        const payload = {
          course_id: selectedCourses,
          department_ids: selectedDepartment,
        };

        console.log("Payload:", payload);

        const response = await AssignCourse(Token, payload);
        console.log(response);

        if (response && response.status === 200) {
          notification.success({
            message: "Success",
            description: "Courses assigned successfully!",
          });
          this.setState({ assignCourseVisible: false });
        } else {
          notification.error({
            message: "Error",
            description: response.message || "Failed to assign courses.",
          });
        }
      } catch (error) {
        console.error("Error submitting courses:", error);
        notification.error({
          message: "Error",
          description: "Failed to assign courses. Please try again.",
        });
      }
    } else {
      alert("Please fill all fields.");
    }

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  showBulkUploadModal = () => {
    this.setState({
      bulkUploadVisible: true,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
      selectedDepartment: "",
    });
  };

  showAssignModal = () => {
    this.setState({
      assignCourseVisible: true, // Opens the modal
      selectedCourses: [], // Initialize or reset selected courses
      selectedDepartment: [], // Initialize or reset selected department
    });

    // Fetch courses when the modal is opened
    this.fetchCourses();
  };

  showExportModal = async () => {
    try {
      const { Token } = this.props;
      let userData = await exportUsers(Token);

      if (userData.file) {
        window.open(userData.file, "_blank");
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  convertToCSV = (data) => {
    if (data.length === 0) return "";
    const header = Object.keys(data[0]);
    const rows = data.map(
      (item) =>
        header
          .map((key) => {
            let value = item[key] || "";
            if (typeof value === "string" && value.includes(",")) {
              value = `"${value.replace(/"/g, '""')}"`;
            }
            return value;
          })
          .join(",") // Join the values by commas
    );
    return [header.join(","), ...rows].join("\n");
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      bulkUploadVisible: false,
      selectedType: "",
      selectedDepartment: [],
      assignCourseVisible: false,
      selectedCourses: [{ course: null, maxUsers: "" }],
    });
  };

  render() {
    const { primaryColor, LoginData } = this.props;
    const canAdd = checkPermission(LoginData, "user", "add");
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* ADD BUTTON */}
          <div
            onClick={canAdd ? this.showModal : null}
            style={{
              width: "100px",
              backgroundColor: primaryColor,
              color: "white",
              padding: "7px 0px",
              textAlign: "center",
              borderRadius: "50px",
              cursor: canAdd ? "pointer" : "not-allowed",
              opacity: canAdd ? 1 : 0.5,
              pointerEvents: canAdd ? "auto" : "none",
            }}
          >
            ADD
          </div>

          {/* BULK UPLOAD BUTTON */}
          <div
            onClick={canAdd ? this.showBulkUploadModal : null}
            style={{
              padding: "7px 16px",
              backgroundColor: primaryColor,
              color: "white",
              textAlign: "center",
              borderRadius: "50px",
              cursor: canAdd ? "pointer" : "not-allowed",
              opacity: canAdd ? 1 : 0.5,
              pointerEvents: canAdd ? "auto" : "none",
            }}
          >
            Bulk Upload
          </div>

          {/* EXPORT BUTTON */}
          <div
            onClick={this.showExportModal}
            style={{
              width: "100px",
              backgroundColor: primaryColor,
              color: "white",
              padding: "7px 0px",
              textAlign: "center",
              borderRadius: "50px",
              cursor: "pointer",
              right: "10px",
            }}
          >
            Export
          </div>
        </div>
        <CustomModal
          width="600px"
          title="Bulk Upload"
          visible={this.state.bulkUploadVisible}
          onCancel={this.handleCancel}
          onOk={this.handleBulkUpload}
          maskClosable={false}
        >
          <div className="premium-upload-container">
            <div className="csv-format-info" style={{ marginBottom: "15px" }}>
              <div className="csv-format-title">CSV Header Format Example</div>
              <p style={{ margin: 0, fontSize: "13px", color: "#334155" }}>
                Ensure your CSV file contains these header columns in this sequence (Group is optional):
              </p>
              <div style={{
                background: "#ffffff",
                border: "1px solid #adc6ff",
                borderRadius: "6px",
                padding: "8px 12px",
                marginTop: "8px",
                fontFamily: "monospace",
                fontSize: "12px",
                color: "#1d39c4",
                whiteSpace: "nowrap",
                overflowX: "auto"
              }}>
                First Name, Last Name, Email, Department, Category, Site, Group
              </div>
            </div>


            <StyledDragger
              accept=".csv"
              className="premium-upload-dragger"
              fileList={
                this.state.file
                  ? [{ uid: "-1", name: this.state.file.name, status: "done" }]
                  : []
              }
              beforeUpload={(file) => {
                this.setState({ file });
                return false; // Prevent default upload
              }}
              onRemove={() => {
                this.setState({ file: null });
              }}
            >
              <div className="premium-upload-icon-wrapper">
                <svg viewBox="0 0 24 24">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                </svg>
              </div>
              <p className="premium-upload-text">
                Click or drag CSV file to this area
              </p>
              <p className="premium-upload-hint">
                Supports single CSV file upload (.csv)
              </p>
            </StyledDragger>

            <div className="premium-upload-actions">
              <Button
                className="premium-cancel-btn"
                onClick={this.handleCancel}
              >
                Cancel
              </Button>
              <Button
                className="premium-upload-btn"
                disabled={!this.state.file}
                onClick={this.handleBulkUpload}
              >
                Upload
              </Button>
            </div>
          </div>
        </CustomModal>

        {/* // <div
        //   onClick={this.showModal}
        //   style={{
        //     width: "100px",
        //     backgroundColor: primaryColor,
        //     color: "white",
        //     padding: "7px 0px",
        //     textAlign: "center",
        //     borderRadius: "50px",
        //   }}
        // >
        //   ADD
        // </div> */}

        <CustomModal
          destroyOnClose={true}
          title="Add User"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          maskClosable={false}
        >
          <Content style={{ background: "#fff", padding: "10px 20px" }}>
            <style>{`
              .add-user-form .formik-field_wrap {
                display: flex;
                gap: 16px;
                margin-bottom: 16px;
              }
              .add-user-form .formik-field-left,
              .add-user-form .formik-field-right {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 6px;
                font-weight: 500;
                color: #4b5563;
                font-size: 13px;
              }
              .add-user-form input,
              .add-user-form select {
                border-radius: 6px !important;
                border: 1px solid #d1d5db !important;
                padding: 6px 12px !important;
                font-size: 14px !important;
                height: 38px !important;
                transition: all 0.2s ease;
                outline: none !important;
              }
              .add-user-form input:focus,
              .add-user-form select:focus {
                border-color: ${primaryColor || '#4466f2'} !important;
                box-shadow: 0 0 0 3px ${(primaryColor || '#4466f2')}25 !important;
              }
              .add-user-form select {
                appearance: none;
                background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%234b5563' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right 12px center;
                background-size: 16px;
                padding-right: 32px !important;
              }
              .add-user-form .ant-select-selector {
                border-radius: 6px !important;
                border: 1px solid #d1d5db !important;
                min-height: 38px !important;
                padding: 3px 6px !important;
              }
              .add-user-form .ant-select-focused .ant-select-selector {
                border-color: ${primaryColor || '#4466f2'} !important;
                box-shadow: 0 0 0 3px ${(primaryColor || '#4466f2')}25 !important;
              }
              .add-user-form .error-text {
                color: #ef4444;
                font-size: 12px;
                margin: 2px 0 0 0;
              }
              .add-user-form .btn-submit {
                height: 40px !important;
                border-radius: 6px !important;
                font-weight: 600 !important;
                background-color: ${primaryColor || '#4466f2'} !important;
                border-color: ${primaryColor || '#4466f2'} !important;
                color: #fff !important;
                box-shadow: 0 4px 12px ${(primaryColor || '#4466f2')}30 !important;
                transition: all 0.2s ease !important;
                width: 100px;
                margin-top: 10px;
              }
              .add-user-form .btn-submit:hover {
                opacity: 0.9;
                transform: translateY(-1px);
                box-shadow: 0 6px 16px ${(primaryColor || '#4466f2')}40 !important;
              }

              /* Bulk Upload Styles */
              .bulk-upload-container {
                display: flex;
                flex-direction: column;
                gap: 16px;
                padding: 10px 0;
                font-family: inherit;
              }
              .upload-drag-area {
                border: 2px dashed #d9d9d9;
                border-radius: 8px;
                padding: 36px 20px;
                text-align: center;
                background: #fafafa;
                cursor: pointer;
                transition: border-color 0.25s, background-color 0.25s;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 10px;
              }
              .upload-drag-area:hover {
                border-color: ${primaryColor || '#4466f2'};
                background: ${(primaryColor || '#4466f2')}08;
              }
              .upload-icon-wrapper {
                font-size: 36px;
                color: ${primaryColor || '#4466f2'};
                opacity: 0.85;
                transition: transform 0.2s;
              }
              .upload-drag-area:hover .upload-icon-wrapper {
                transform: translateY(-2px);
              }
              .upload-text {
                font-size: 15px;
                font-weight: 600;
                color: #333;
                margin: 0;
              }
              .upload-hint {
                font-size: 12px;
                color: #666;
                margin: 0;
              }
              .selected-file-card {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 14px 18px;
                background: #f6ffed;
                border: 1px solid #b7eb8f;
                border-radius: 8px;
                transition: all 0.3s ease;
              }
              .selected-file-info {
                display: flex;
                align-items: center;
                gap: 10px;
                color: #237804;
                font-weight: 600;
                font-size: 14px;
              }
              .remove-file-btn {
                color: #8c8c8c;
                cursor: pointer;
                font-weight: 500;
                font-size: 13px;
                transition: color 0.2s;
                padding: 2px 8px;
                border-radius: 4px;
              }
              .remove-file-btn:hover {
                color: #ff4d4f;
                background: #fff0f6;
              }
              .csv-format-info {
                background: #f0f5ff;
                border-radius: 8px;
                padding: 16px;
                border-left: 4px solid ${primaryColor || '#4466f2'};
              }
              .csv-format-title {
                font-size: 14px;
                font-weight: 700;
                color: #002c8c;
                margin-bottom: 8px;
              }
              .csv-format-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-top: 10px;
              }
              .csv-tag {
                background: #fff;
                border: 1px solid #adc6ff;
                border-radius: 4px;
                padding: 3px 8px;
                font-size: 12px;
                color: #1d39c4;
                font-family: monospace;
                font-weight: 600;
              }

              /* Compact overrides for Bulk Upload Modal */
              .premium-upload-container .premium-upload-dragger.ant-upload-btn,
              .premium-upload-container .premium-upload-dragger .ant-upload-drag {
                padding: 1.25rem 1rem !important;
                border-radius: 12px !important;
              }
              .premium-upload-container .premium-upload-icon-wrapper {
                width: 44px !important;
                height: 44px !important;
                margin-bottom: 0.5rem !important;
              }
              .premium-upload-container .premium-upload-icon-wrapper svg {
                width: 22px !important;
                height: 22px !important;
              }
              .premium-upload-container .premium-upload-text {
                font-size: 0.95rem !important;
                margin-bottom: 0.25rem !important;
              }
              .premium-upload-container .premium-upload-hint {
                font-size: 0.8rem !important;
              }
              .premium-upload-container .premium-upload-actions {
                margin-top: 1rem !important;
                padding-top: 0.75rem !important;
              }
              .premium-upload-container .premium-upload-btn.ant-btn,
              .premium-upload-container .premium-cancel-btn.ant-btn {
                height: 36px !important;
                padding: 0 1.5rem !important;
              }
            `}</style>
            <div className="add-user-form">
              <Formik
                initialValues={{
                  email: "",
                  first_name: "",
                  last_name: "",
                  selectedDepartment: [],
                  category: "",
                  site: "",
                  group_id: "",
                }}
                validate={this.validateForm}
                onSubmit={this.handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  setFieldTouched,
                  isSubmitting,
                }) => {
                  return (
                    <div>
                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          First Name
                          <Input
                            id="first_name"
                            placeholder="First Name"
                            value={values.first_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.first_name && touched.first_name ? (
                            <p className="error-text">
                              {errors.first_name}
                            </p>
                          ) : null}
                        </div>

                        <div className="formik-field-right">
                          Last Name
                          <Input
                            id="last_name"
                            placeholder="Last Name"
                            value={values.last_name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.last_name && touched.last_name ? (
                            <p className="error-text">
                              {errors.last_name}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <div className="formik-field_wrap">
                        {/* Email Field (Always Visible) */}
                        <div className="formik-field-left">
                          Email
                          <Input
                            id="email"
                            placeholder="Email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.email && touched.email ? (
                            <p className="error-text">
                              {errors.email}
                            </p>
                          ) : null}
                        </div>
                        {/* Department Field (Only for Corporate User) */}
                        {LoginData.role === "corporate" && (
                          <div className="formik-field-right" style={{ width: "100%" }}>
                            <label style={{ display: "block", marginBottom: "6px", fontWeight: "500", color: "#4b5563", fontSize: "13px" }}>
                              Department <span style={{ color: "#ef4444" }}>*</span>
                            </label>
                            <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                              <select
                                id="single_dept_select"
                                className="form-control"
                                value={this.state.tempSelectedDept || ""}
                                onChange={(e) => this.setState({ tempSelectedDept: e.target.value })}
                                style={{
                                  flex: 1,
                                  height: "38px",
                                  borderRadius: "6px",
                                  border: "1px solid #d1d5db",
                                  padding: "0 12px",
                                  fontSize: "14px",
                                  color: "#0f172a",
                                  backgroundColor: "#ffffff",
                                  outline: "none"
                                }}
                              >
                                <option value="">Select Department</option>
                                {this.state.departments &&
                                  this.state.departments
                                    .filter(dept => !(values.selectedDepartment || []).includes(dept._id))
                                    .map((dept) => (
                                      <option key={dept._id} value={dept._id}>
                                        {dept.name}
                                      </option>
                                    ))}
                              </select>
                              <button
                                type="button"
                                onClick={() => {
                                  if (this.state.tempSelectedDept) {
                                    const current = values.selectedDepartment || [];
                                    if (!current.includes(this.state.tempSelectedDept)) {
                                      const updated = [...current, this.state.tempSelectedDept];
                                      setFieldValue("selectedDepartment", updated);
                                    }
                                    this.setState({ tempSelectedDept: "" });
                                  }
                                }}
                                style={{
                                  height: "38px",
                                  padding: "0 16px",
                                  backgroundColor: primaryColor || "#4466f2",
                                  color: "#ffffff",
                                  border: "none",
                                  borderRadius: "6px",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap"
                                }}
                              >
                                Add
                              </button>
                            </div>

                            {/* Added Departments Pills Box */}
                            {values.selectedDepartment && values.selectedDepartment.length > 0 && (
                              <div style={{
                                marginTop: "10px",
                                padding: "8px 12px",
                                backgroundColor: "#f8fafc",
                                border: "1px solid #e2e8f0",
                                borderRadius: "8px",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                                minHeight: "42px",
                                alignItems: "center"
                              }}>
                                {values.selectedDepartment.map((deptId) => {
                                  const deptObj = (this.state.departments || []).find(d => d._id === deptId);
                                  return (
                                    <span
                                      key={deptId}
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        backgroundColor: "#e0e7ff",
                                        color: "#3730a3",
                                        padding: "4px 10px",
                                        borderRadius: "16px",
                                        fontSize: "12px",
                                        fontWeight: "500"
                                      }}
                                    >
                                      {deptObj ? deptObj.name : deptId}
                                      <span
                                        onClick={() => {
                                          const updated = values.selectedDepartment.filter(id => id !== deptId);
                                          setFieldValue("selectedDepartment", updated);
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          color: "#4338ca",
                                          lineHeight: 1
                                        }}
                                      >
                                        &times;
                                      </span>
                                    </span>
                                  );
                                })}
                              </div>
                            )}

                            {errors.selectedDepartment && touched.selectedDepartment ? (
                              <p className="error-text">
                                {errors.selectedDepartment}
                              </p>
                            ) : null}
                          </div>
                        )}
                      </div>

                      <div className="formik-field_wrap">
                        {/* Category Field  */}
                        <div className="formik-field-left">
                          Category
                          <Input
                            id="category"
                            placeholder="Category"
                            value={values.category}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="formik-field-right">
                          Site
                          <Input
                            id="site"
                            placeholder="Site"
                            value={values.site}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>

                      {LoginData && (LoginData.role === "SUPERADMIN" || LoginData.role === "SUBADMIN" || LoginData.role === "admin") && (
                        <div className="formik-field_wrap">
                          <div className="formik-field-left" style={{ width: "100%" }}>
                            Group (Corporate Group)
                            <select
                              id="group_id"
                              name="group_id"
                              value={values.group_id}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="form-control"
                              style={{
                                width: "100%",
                                cursor: "pointer"
                              }}
                            >
                              <option value="">Select Group</option>
                              {this.state.corporateGroups && this.state.corporateGroups.map((group) => (
                                <option key={group._id} value={group._id}>
                                  {group.first_name ? `${group.first_name} ${group.last_name || ''}`.trim() : (group.username || group.email)}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}

                      <Button
                        type="primary"
                        className="btn-submit"
                        onClick={handleSubmit}
                      >
                        Add
                      </Button>
                    </div>
                  );
                }}
              </Formik>
            </div>
          </Content>
        </CustomModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

export default connect(mapStateToProps)(withRouter(AddUser));
